import { computed } from 'vue';

export function resolveDataTest(dataTest?: string, id?: string | null): string | undefined {
  return dataTest || id || undefined;
}

export function resolveMenuDataTest(dataTest?: string, id?: string | null): string | undefined {
  const resolved = resolveDataTest(dataTest, id);
  return resolved ? `${resolved}-menu` : undefined;
}

export function useDataTest(dataTest?: string, id?: string | null) {
  const resolvedDataTest = computed(() => resolveDataTest(dataTest, id));
  const resolvedMenuDataTest = computed(() => resolveMenuDataTest(dataTest, id));

  return {
    resolvedDataTest,
    resolvedMenuDataTest,
  };
}
